import MsBHUMultiSiteModalContainer from './container'
export default MsBHUMultiSiteModalContainer
